/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {Component, useState} from 'react';
import AlertService from '../../services/alerts.service';
import 'react-tabs/style/react-tabs.css';
import "../../CSS/DataModal.css";
import CreateAlertModal from "../AssetStateTool/CreateAlertModal";
import FullLoader from "../Loader/FullLoader";
import Snackbar from "@mui/material/Snackbar";

function CreateAlertButton(props) {
    const { assetId } = props;
    const [loading, setLoading] = useState(false);
    const [alertTypes, setAlertTypes] = useState([]);
    const [showCreateAlertModal, setShowCreateAlertModal] = useState(false);
    const [statusMessage, setStatusMessage] = useState("");
    const [showMessage, setShowMessage] = useState(false);
    
    const onCreateAlertClick = async () => {
        await AlertService.getalerttypes()
            .then(response => {
                if (response !== null && response !== undefined) {
                    setAlertTypes(response.data);
                }
                setShowCreateAlertModal(true);
            })
            .catch(e => {
                console.log(e);
            });
    }
    
    const onShowCreateAlertModal = () => {
        setShowCreateAlertModal(!showCreateAlertModal);
    }
    
    const onCreateAlert = async (newAlert) => {
        setShowCreateAlertModal(false);
        setLoading(true);
        await AlertService.addalert(newAlert)
            .then(response => {
                if (response.status === 200) {
                    setStatusMessage(`Successfully added new alert to assetId: ${newAlert.sourceId}`);
                }
                else {
                    setStatusMessage(`Failed to add new alert to assetId: ${newAlert.sourceId}.`);
                }
                setShowMessage(true);
                setLoading(false);

                setTimeout(() => {
                    setStatusMessage("");
                    setShowMessage(false);
                }, 3000);
            })
            .catch(e => {
                console.log(e);
                setStatusMessage(`Failed to add new alert to assetId: ${newAlert.sourceId}.`);
                setShowMessage(true);
                setLoading(false);

                setTimeout(() => {
                    setStatusMessage("");
                    setShowMessage(false);
                }, 3000);
            });
    }
    
    let loader = loading ? 
        <FullLoader />
        : null;
    
    return (
        <div>
            <button className="secondary-btn btn-small width-140 margin-bottom-2" onClick={onCreateAlertClick}>
                Create Alert
            </button>
            {loader}
            
            <CreateAlertModal show={showCreateAlertModal} onYes={onCreateAlert} onClick={onShowCreateAlertModal} alertTypes={alertTypes} assetId={assetId}/>
            <Snackbar open={showMessage} message={statusMessage} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={6000} />
        </div>
    )
}
export default CreateAlertButton;